<template>
  <section class="pb-20 sm:pb-30 md:pb-30 lg:pb-30 relative block bg-gray-900">
    <div
      class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
      style="height: 80px; transform: translateZ(0px);"
    >
      <angled-s-v-g colorClass="text-gray-900"></angled-s-v-g>
    </div>
    <div class="container mx-auto px-4 lg:pt-24 lg:pb-64">
      <div class="flex flex-wrap text-center justify-center">
        <div class="w-full lg:w-6/12 px-4">
          <h2 class="text-4xl font-semibold text-white">Starten Sie jetzt Ihr Projekt</h2>
          <p class="text-lg leading-relaxed mt-4 mb-4 text-gray-500">
            Gehen Sie den nächsten Schritt und nehmen Sie unverbindlich mit uns Kontakt auf.
            Wir beraten Sie gerne und planen mit Ihnen gemeinsam die nächsten Schritte.
          </p>
        </div>
      </div>
      <div class="flex flex-wrap mt-12 justify-center">
        <div class="w-full lg:w-3/12 px-4 text-center">
          <div
            class="text-gray-900 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center"
          >
            <i class="fas fa-desktop text-xl"></i>
          </div>
          <h6 class="text-xl mt-5 font-semibold text-white">Softwarelösungen</h6>
          <p class="mt-2 mb-4 text-gray-500">
            Wir setzten Ihr indiviuelles Softwareprojekt professionell um.
          </p>
        </div>
        <div class="w-full lg:w-3/12 px-4 text-center">
          <div
            class="text-gray-900 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center"
          >
            <i class="fas fa-cloud text-xl"></i>
          </div>
          <h5 class="text-xl mt-5 font-semibold text-white">Cloud Consulting</h5>
          <p class="mt-2 mb-4 text-gray-500">
            Gerne beraten wir Sie über Ihre Möglichkeiten in der Cloud.
          </p>
        </div>
        <div class="w-full lg:w-3/12 px-4 text-center">
          <div
            class="text-gray-900 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center"
          >
            <i class="fas fa-user-friends text-xl"></i>
          </div>
          <h5 class="text-xl mt-5 font-semibold text-white">Verstärken Sie ihr Team</h5>
          <p class="mt-2 mb-4 text-gray-500">
            Unsere Engineers unterstützen Sie in Ihren Projekten.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AngledSVG from "../components/Base/AngledSVG.vue";
export default {
  components: {
    AngledSVG
  }
};
</script>

<style>
</style>